import { createFileRoute } from '@tanstack/react-router';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';
import { MachineSheet } from '@/pages/machines/detail/machine-sheet';
import { MACHINES_ROUTE } from '@/pages/machines/lib/routes';

export const Route = createFileRoute('/protected/_layout/machines/_layout/$id')(
  {
    ...createSheetRouteOptions(MACHINES_ROUTE, { size: 'wide' }),
    component: MachineRoute,
  }
);

function MachineRoute() {
  const { id } = Route.useParams();
  return <MachineSheet key={id} id={id} returnUrl={MACHINES_ROUTE} />;
}
